<template>
     <div class="card-blue-large">
             
              <div class="row">
                <div class="col-2">
                  <img class="img-icon" src="@/assets/antarmuka-user/img/completed_task_.png" alt="">
                </div>
                <div class="col-4">
                     <p class="text-xxxl text-bold vertical-align">Total Project</p>
                </div>
                <div class="col-6">
                  <div class="text-xxxxl text-bold total-project text-right vertical-align">
                      {{totalProject}}
                  </div>
                </div>
              </div>
            </div>
</template>

<script>
export default {
    name: "TotalProject",
    props: ["totalProject"]
}
</script>


// WEBPACK FOOTER //
// src/components/Home/TotalProject.vue